<template>
  <div class="technical-notes">
    <div
      v-for="(item, index) in computedObj"
      :key="index"
      class="item"
    >
      <div class="label">
        {{ item.title }}
      </div>
      <div class="value">
        {{ item.text }}
      </div>
    </div>

    <template v-if="hasLimit">
      <div class="item">
        <HighlightButton
          button-type="rounded"
          button-style="outline"
          button-size="small"
          title="Show More"
          @click.native="showMore()"
        />
      </div>
    </template>

  </div>
</template>

<script>
// import HighlightButton from '~/components/sales-bar/highlight-button.vue'

export default {
  name: 'technical-notes',
  props: {
    content: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      limit: 4
    }
  },
  computed: {
    displayItems() {
      const items = []
      const notes = this.$store.getters['products/getMap']('variable')['technote']
      for (const item of this.content) {
        items.push({ ...item, title: notes[item.title] ?? item.title.ucFirst() })
      }
      return items
    },
    hasLimit() {
      return this.limit != null && this.content.length > this.limit
    },
    computedObj() {
      return this.limit ? this.displayItems.slice(0, this.limit) : this.displayItems
    }
  },
  methods: {
    showMore() {
      return this.limit = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.technical-notes {
  --col-size:2;

  @include media-breakpoint-up(sm) { --col-size:3; }
  @include media-breakpoint-up(lg) { --col-size:5; }
}

.technical-notes {
  display: grid;
  grid-template-columns: repeat(var(--col-size), 1fr);
  grid-gap: 1.5em;
  gap: 1.5em;

  .item {
    grid-column: span 1;
    display: flex;
    flex-direction: column;
  }

  .label {
    font-weight:600;
    font-family:var(--main-heading-font);
  }
}
</style>>
